import styled, { css } from 'styled-components';
import { SNAP_HEIGHT } from './constants';

interface ButtonSelectProps {
  selected?: boolean;
}

interface ContainerProps {
  containerWidth?: number;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  align-items: center;
  gap: 0 4px;
  position: relative;
  height: 106px;
  border-right: 1px solid #413d50;
  padding-right: 12px;
  margin-right: 12px;

  &:last-child {
    padding-right: 0;
    margin-right: 0;
    border-right-width: 0;
  }

  ${({ containerWidth }) =>
    containerWidth
      ? css`
          width: ${containerWidth}px;
          flex: 0 0 ${containerWidth}px;
        `
      : css`
          width: 100%;
        `}
`;

export const ScrollContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const Scrollable = styled.ul`
  width: 100%;
  height: 100%;
  padding: 40px 16px;
  overflow: auto;
  scroll-snap-type: y mandatory;
`;

export const Holder = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: ${SNAP_HEIGHT}px;
  border-radius: 4px;
  background: #373245;
  transform: translate3d(0, -50%, 0);
`;

export const ButtonSelect = styled.button<ButtonSelectProps>`
  position: relative;
  width: 100%;
  height: ${SNAP_HEIGHT}px;
  color: #bcb8c3;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.24px;
  line-height: ${SNAP_HEIGHT}px;
  z-index: 2;
  scroll-snap-align: center;

  ${({ selected }) =>
    selected &&
    css`
      color: #e8e3ee;
      font-weight: 500;
      font-size: 17px;
    `}
`;

export const Surfix = styled.div`
  position: relative;
  z-index: 2;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.5px;
  color: #756f7e;
  word-break: keep-all;
`;
